import React from 'react';

import { BankList } from '@C/Reports/_utils/BankList';

import { LedgerReport } from '../LedgerReport';

const BankLedger = () => {
  return (
    <LedgerReport
      title="Bank Ledger"
      entityLabel="Bank Name"
      SelectorComponent={BankList}
      source="SELF"
      showTotals={false}
      dateRangeLimit={6}
      dateRangeLimitType="month"
    />
  );
};

export { BankLedger };
